import { TreeView } from '@lexical/react/LexicalTreeView'

import { useEditor } from '../../hooks/useEditor'

export const TreeViewPlugin = () => {
  const editor = useEditor()

  return <TreeView editor={editor} />
}
